import { Injectable } from "@angular/core";
import { AppState } from "@core/store";
import * as GlobalAction from "@core/store/actions/global.action";
import * as GlobalRed from "@core/store/reducers/global.reducer";
import { select, Store } from "@ngrx/store";

@Injectable()
export class PickingPointMultiselectFacade {
  constructor(private store: Store<AppState>) {}
  public getPickingPoints$ = this.store.pipe(select(GlobalRed.getSerializedPickingPoints));
  private getUi$ = this.store.pipe(select(GlobalRed.getUiGlobal));

  public getLoadingPickingPoints$ = this.getUi$.pipe(select(s => s.loadPickingPoints));

  public fetchPickingPoints() {
    this.store.dispatch(GlobalAction.fetchPickingPoints({ ascendingName: true }));
  }
}
